import { render, staticRenderFns } from "./txth_detail.vue?vue&type=template&id=798c5f09&scoped=true&"
import script from "./txth_detail.vue?vue&type=script&lang=js&"
export * from "./txth_detail.vue?vue&type=script&lang=js&"
import style0 from "./txth_detail.vue?vue&type=style&index=0&id=798c5f09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798c5f09",
  null
  
)

export default component.exports